import './index.scss';
import Skeleton from '@mui/material/Skeleton';

const DashboardSkeleton = () => {
    return (
        <div className="my-account__content">
            <div className="below-32">
                <h1 className="my-account__content__title">
                    <Skeleton animation="wave" variant="text" className="myAccountTitle" height={40} />&nbsp;
                </h1>
                <p className="my-account__content__summary">
                    <Skeleton animation="wave" variant="text" className="myAccountSummary" />
                </p>
            </div>
            <div className="row top-48">
                <div className="col-sm-6 pad-t-12">
                    <div className="my-account__dashboard">
                        <Skeleton animation="wave" variant="rounded" style={{ width: "60%" }} />
                        <h3 className="my-account__dashboard__subtitle"></h3>
                        <div className="top-16 below-32">
                            <ul className="definition--inline">
                                <li>
                                    <Skeleton animation="wave" variant="text" className="myAccountList" />
                                </li>
                                <li>
                                    <Skeleton animation="wave" variant="text" className="myAccountList" />
                                </li>
                                <li>
                                    <Skeleton animation="wave" variant="text" className="myAccountList" />
                                </li>
                            </ul>
                            <Skeleton animation="wave" variant="rounded" className="pernalisationLink" />
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 pad-t-12">
                    <div className="my-account__dashboard">
                        <h3 className="my-account__dashboard__subtitle">
                            <Skeleton animation="wave" variant="rounded" style={{ width: "60%" }} />
                        </h3>
                        <div className="top-16 below-32">
                            <div id="email-subscription-state">
                                <Skeleton animation={'wave'} variant="rounded" height={90} />
                            </div>
                            <Skeleton animation="wave" variant="rounded" className="pernalisationLink" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row address-section">
                <div className="col-sm-12">
                    <div>
                        <h3 className="my-account__content__title">
                            <Skeleton animation="wave" variant="text" className="addressSection" />&nbsp;
                        </h3>
                        <div className="top-16 below-24">
                            <strong className="capitalize">
                                <Skeleton animation="wave" variant="text" width={300} height={25} />&nbsp;
                            </strong>
                            <div id="addresses">
                                <Skeleton animation={'wave'} variant="rounded" height={90} width={200} />
                            </div>
                        </div>
                        <div className="top-16 below-24">
                            <strong className="capitalize">
                                <Skeleton animation="wave" variant="text" width={300} height={25} />&nbsp;
                            </strong>
                            <div id="addresses">
                                <Skeleton animation={'wave'} variant="rounded" height={90} width={200} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6"></div>
            </div>
        </div>
    );
};
export default DashboardSkeleton;